import { useSelector } from "react-redux";

import { selectFeatures } from "../store/reducers/sessionSlice";

/**
 * Reads the generic feature-flag map (e.g. `DOCTOR_LICENCE`, `MANAGER_LICENCE`)
 * from Redux state. This map is populated once, at `/validate-session` time,
 * from the `settings.features` field of the session response — this hook does
 * NOT make its own network call (unlike `useAppNotices`, which resolves the
 * legacy MAINTENANCE/ANNOUNCEMENT banner flags via separate API calls).
 */
export const useFeatureFlags = (): Record<string, boolean> => {
  return useSelector(selectFeatures);
};

/**
 * Convenience wrapper to read a single feature flag by name.
 * Defaults to `false` when the flag is absent from the map.
 */
export const useFeatureFlag = (flagName: string): boolean => {
  const features = useFeatureFlags();
  return features[flagName] === true;
};

export default useFeatureFlags;
